import app from '../main'
import { getJsonStorage } from "./storage";
import { getBrowserType } from "./common";
import { searchAccessGoods,createAccessOrder,wechatPrepay,createRoleOrder } from '../api/api'

export const wechatPayRoleGoods = (role_goods_id,callback) => {
  let browserType = getBrowserType();
  if(browserType > 0) {
    let user = getJsonStorage('openai_user');
    if(user && user.user_wechat_id) {
      createRoleOrder(role_goods_id).then(res => {
        if(res && res.status ===0){
          wechatPrepay(res.data.order_id, user.user_wechat_id).then(pres => {
            if(pres && pres.status === 0){
              if(browserType === 2){
                WeixinJSBridge.invoke('getBrandWCPayRequest',{
                  appId:pres.data.appId,
                  timeStamp: pres.data.timeStamp,
                  nonceStr: pres.data.nonceStr,
                  package: pres.data.prepayId,
                  signType: pres.data.signType,
                  paySign: pres.data.paySign
                },(res)=>{
                  callback({err_msg:res.errMsg || res.err_msg || JSON.stringify(res)});
                })
              }else{
                app.$wx.miniProgram.navigateTo({
                  url:'/pages/index/pay?params='+encodeURIComponent(JSON.stringify({
                    appId:pres.data.appId,
                    timeStamp: pres.data.timeStamp,
                    nonceStr: pres.data.nonceStr,
                    package: pres.data.prepayId,
                    signType: pres.data.signType,
                    paySign: pres.data.paySign
                  }))
                })
              }
            }
          });
        }else{
          callback({err_msg:'订单创建失败'});
        }
      });
    }else{
      callback({err_msg:'未登录过小程序获取OpenID'});
    }
  }else{
    callback({err_msg:'暂未开通该支付方式,请使用微信或小程序'});
  }
};

export const wechatPayAccessGoods = (access_goods_id,callback) => {
  let browserType = getBrowserType();
  if(browserType > 0){
    let user = getJsonStorage('openai_user');
    if(user && user.user_wechat_id){
      createAccessOrder(access_goods_id).then(ores => {
        if(ores && ores.status === 0){
          wechatPrepay(ores.data.order_id,user.user_wechat_id).then(pres => {
            if(pres && pres.status === 0){
              if(browserType === 2){
                WeixinJSBridge.invoke('getBrandWCPayRequest',{
                  appId:pres.data.appId,
                  timeStamp: pres.data.timeStamp,
                  nonceStr: pres.data.nonceStr,
                  package: pres.data.prepayId,
                  signType: pres.data.signType,
                  paySign: pres.data.paySign
                },(res)=>{
                  alert(JSON.stringify(res));
                  callback({err_msg:res.errMsg || res.err_msg || JSON.stringify(res),order_id:ores.data.order_id});
                })
              }else{
                app.$wx.miniProgram.redirectTo({
                  url:'/pages/index/pay?params='+encodeURIComponent(JSON.stringify({
                    appId:pres.data.appId,
                    timeStamp: pres.data.timeStamp,
                    nonceStr: pres.data.nonceStr,
                    package: pres.data.prepayId,
                    signType: pres.data.signType,
                    paySign: pres.data.paySign
                  }))
                })
              }
            }else{
              callback({err_msg:pres.message});
            }
          });
        }else{
          callback({err_msg:ores.message});
        }
      })
    }else{
      callback({err_msg:'未登录过小程序获取OpenID'});
    }
  }else{
    callback({err_msg:'暂未开通该支付方式,请使用微信或小程序'});
  }
};



// WEBPACK FOOTER //
// ./src/util/pay.js